import React, { useContext, useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { GlobalContext } from "../../Context/GlobalState";
import { billpunchbasicauth } from "../../utils/Credentials";
import { BASE_URL_API_TRANXT_UAT_API } from "../../utils/Constant";
import { ViewExpenseTableEmployee } from "./Table";
import { useQuery } from "../../utils/useQuery";
const arr = [{ label: "Name", value: "Name" }];
const Viewexpanseemployee = () => {
  const query = useQuery();
  const id = query.get("id");

  const { user,setTransactionLoaderState } = useContext(GlobalContext);
  const [data, setData] = useState([]);
  const { password , username } = billpunchbasicauth;
 
  const getPropertyExpense = async (e) => {
    setTransactionLoaderState(true);
    try {
        const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
         empid: user.userid,
         firmid:user.firm_id,
      });

      var requestOptions = {
        method: "POST",
        headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetFirmExpense`,
        requestOptions
      );
      const data = await res.json();
      if (data.status == "0") {
        setData(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
    }
    setTransactionLoaderState(false);
  };
 
  useEffect(() => {
    getPropertyExpense();
  }, []);

  return (
    <>
      <div className="mt-4">
        <div className=" row mx-1 p-0 mt-3">
          <h4 className="col  d-flex align-items-center ">
            {" "}
             Expenses List
          </h4>

          <div className=" col-2 mr-md-4 mr-sm-3 d-flex justify-content-end">
            {" "}
            <Link to={"/Employee/expense-management"}>
              <button
                type="button"
                className="btn btn-sm align-items-center justify-content-center"
                style={{
                  background: "#2ca01c",
                  borderRadius: ".4em",
                  height: "2.5em",
                  // width: "8rem",
                  border: "None",
                  color: "#fff",
                }}
              >
                Back
              </button>
            </Link>
          </div>
        </div>

        <div
          className=" p-0 "
          style={{
            borderTopLeftRadius: "1rem",
            borderTopRightRadius: "1rem",
          }}
        >
          <ViewExpenseTableEmployee data={data} />
        </div>
      </div>
    </>
  );
};

export default Viewexpanseemployee;
